// extracted by mini-css-extract-plugin
module.exports = {"token":"Token_token__2gp1y"};